import {
  Button,
  Checkbox,
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Switch,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import ReadingRequestSelector from "./ReadingRequestSelector";

function ReadingOrderPublishForm({ handleSubmit, isLoading, readingOrder }) {
  const [isRequest, setIsRequest] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [publicationMode, setPublicationMode] = useState(
    readingOrder?.scheduledFor ? "schedule" : "publish_now"
  );
  const [scheduledFor, setScheduledFor] = useState(
    readingOrder?.scheduledFor || ""
  );
  const [skipArticle, setSkipArticle] = useState(
    readingOrder?.skipArticleOnPublish || false
  );

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const minimumScheduleDate = [
    tomorrow.getFullYear(),
    `${tomorrow.getMonth() + 1}`.padStart(2, "0"),
    `${tomorrow.getDate()}`.padStart(2, "0"),
  ].join("-");

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({
      publicationMode,
      scheduledFor: publicationMode === "schedule" ? scheduledFor : null,
      requestId: publicationMode === "publish_now" ? selectedRequest : null,
      skipArticle,
    });
  };

  const onSelectRequest = (requestId) => {
    setSelectedRequest(requestId);
  };

  return (
    <form onSubmit={onSubmit}>
      <VStack spacing={4}>
        <FormControl isRequired>
          <FormLabel>Release timing</FormLabel>
          <RadioGroup
            value={publicationMode}
            onChange={(value) => {
              setPublicationMode(value);
              if (value === "schedule") {
                setIsRequest(false);
                setSelectedRequest(null);
              }
            }}
          >
            <HStack spacing="24px">
              <Radio value="publish_now">Publish now</Radio>
              <Radio value="schedule">Schedule</Radio>
            </HStack>
          </RadioGroup>
        </FormControl>

        {publicationMode === "schedule" ? (
          <FormControl isRequired>
            <FormLabel>Release date</FormLabel>
            <Input
              min={minimumScheduleDate}
              onChange={(event) => setScheduledFor(event.target.value)}
              type="date"
              value={scheduledFor}
            />
          </FormControl>
        ) : (
          <FormControl display="flex" alignItems="center">
            <FormLabel htmlFor="is-request" mb="0">
              Was that reading order requested by a user?
            </FormLabel>
            <Switch
              id="is-request"
              isChecked={isRequest}
              onChange={() => setIsRequest(!isRequest)}
            />
          </FormControl>
        )}

        {publicationMode === "publish_now" && isRequest && (
          <ReadingRequestSelector
            requestId={selectedRequest}
            onSelect={onSelectRequest}
          />
        )}

        <FormControl>
          <Checkbox
            id="skip-article"
            isChecked={skipArticle}
            onChange={(event) => setSkipArticle(event.target.checked)}
          >
            Skip article creation
          </Checkbox>
          <FormHelperText>
            {publicationMode === "schedule"
              ? "No article will be created when this reading order is released."
              : "No article will be created for this release."}
          </FormHelperText>
        </FormControl>

        <Button
          colorScheme="blue"
          isLoading={isLoading}
          loadingText={
            publicationMode === "schedule" ? "Scheduling" : "Publishing"
          }
          type="submit"
        >
          {publicationMode === "schedule"
            ? "Schedule reading order"
            : "Publish reading order"}
        </Button>
      </VStack>
    </form>
  );
}

export default ReadingOrderPublishForm;
